import Model from './abstract/Model'
import { ProductType } from './definitions/ProductType'

export default class Product extends Model<ProductType> {}
